export function pickDeviceString(device, ...keys) {
  if (!device) return "";
  for (const key of keys) {
    const v = device[key];
    if (v != null && String(v).trim()) return String(v).trim();
  }
  return "";
}

export function pickBool(device, camelKey, pascalKey) {
  if (!device) return false;
  if (camelKey in device) return coerceBool(device[camelKey]);
  if (pascalKey in device) return coerceBool(device[pascalKey]);
  return false;
}

export function coerceBool(v) {
  if (v === true || v === 1) return true;
  if (v === false || v === 0) return false;
  if (typeof v === "string") return v.trim().toLowerCase() === "true";
  return !!v;
}

/** Matches worker.py device_is_active (default true when API omits field). */
export function isDeviceActive(device) {
  if (!device) return false;
  if ("isActive" in device) return coerceBool(device.isActive);
  if ("IsActive" in device) return coerceBool(device.IsActive);
  return true;
}

export function isDeviceAiProcess(device) {
  if (!device) return false;
  if ("isAiProcess" in device) return coerceBool(device.isAiProcess);
  if ("IsAiProcess" in device) return coerceBool(device.IsAiProcess);
  return true;
}

export function runtimeForDevice(workerStatus, deviceId) {
  if (!workerStatus?.devices) return null;
  return workerStatus.devices.find(
    (d) => Number(d.deviceId) === Number(deviceId)
  );
}

export function mergeDeviceStatus(apiDevice, workerStatus) {
  const rt = runtimeForDevice(workerStatus, apiDevice?.id);
  return {
    apiActive: isDeviceActive(apiDevice),
    apiAi: isDeviceAiProcess(apiDevice),
    rtspIngesting: !!rt?.rtspIngesting,
    rtmpPublishing: !!rt?.rtmpPublishing,
    aiProcessing: !!rt?.aiProcessing,
    workerRunning: !!rt,
  };
}
